export default __webpack_public_path__ + "static/media/toggle-icon.93679d5d.svg";